module.exports = __webpack_public_path__ + "img/6.bc2e752c.jpg";